/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { EnableableFunctions } from "./EnableableFunctions";
import { PaymentMethodInfo } from "./PaymentMethodInfo";
import * as t from "io-ts";
import { DateFromString } from "@pagopa/ts-commons/lib/dates";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum WalletTypeEnum {
  "Card" = "Card",

  "Bancomat" = "Bancomat",

  "Satispay" = "Satispay",

  "BPay" = "BPay",

  "Generic" = "Generic",

  "PayPal" = "PayPal"
}

// required attributes
const WalletV2R = t.interface({});

// optional attributes
const WalletV2O = t.partial({
  createDate: DateFromString,

  enableableFunctions: t.readonlyArray(
    EnableableFunctions,
    "array of EnableableFunctions"
  ),

  favourite: t.boolean,

  idWallet: t.Integer,

  info: PaymentMethodInfo,

  onboardingChannel: t.string,

  pagoPA: t.boolean,

  updateDate: DateFromString,

  walletType: enumType<WalletTypeEnum>(WalletTypeEnum, "walletType")
});

export const WalletV2 = t.intersection([WalletV2R, WalletV2O], "WalletV2");

export type WalletV2 = t.TypeOf<typeof WalletV2>;
